<template>
	<div class="detail">
		<div class="header">
			<div class="left" @click="toIndex()">&lt;返回</div>
			<div class="span1">
				<span>作业详情</span>
			</div>
			<div class="right"></div>
		</div>
		<div class="main">
			<div class="main-title">
				<img src="./img/title-1.svg" alt="" />
				<p>作业详情</p>
			</div>
			<!-- <div class="main-li" v-for="(item, i) in list" :key="i + item.title">
				<p>{{ item.title }}</p>
				<span :style="{ color: item.title === '附件' ? '#4991E1' : '' }" v-if="item.type !== 'ul'">{{
					item.text
				}}</span>
				<ul v-else>
					<li v-for="(item_1, j) in item.text" :key="item_1 + j" style="margin-bottom:5px">{{ item_1 }}</li>
				</ul>
			</div> -->
			<div class="main-li">
				<p>发布人</p>
				<span>{{ list.sendPeople }}</span>
			</div>
			<div class="main-li">
				<p>登记时间</p>
				<span>{{ list.createTime }}</span>
			</div>
			<div class="main-li">
				<p>发布时间</p>
				<span>{{ list.createTime }}</span>
			</div>
			<div class="main-li">
				<p>作业标题</p>
				<span>{{ list.title }}</span>
			</div>
			<div class="main-li">
				<p>完成期限</p>
				<span>{{ list.deadline }}</span>
			</div>
			<div class="main-li">
				<p>预计完成时间</p>
				<span>{{ list.estimateDuration }}</span>
			</div>
			<div class="main-li">
				<p>作业内容</p>
				<span>{{ list.content }}</span>
			</div>
			<div class="main-li">
				<p>附件</p>
				<span>{{ list.resources && list.resources.length ? list.resources : "暂无附件" }}</span>
			</div>
			<div class="main-li">
				<p>设计意图</p>
				<span>{{ list.purpose }}</span>
			</div>

			<div class="main-title" style="margin-top:50px">
				<img src="./img/title-2.svg" alt="" />
				<p>评审记录</p>
			</div>
			<div class="handle">
				<div class="handle-header">
					<span>操作</span>
					<p>审核时间</p>
				</div>
				<div v-for="(item, i) in handleList" :key="i + item.id" class="">
					<div class="handle-item">
						<img src="./img/reject.svg" alt="" v-if="item.state === 'reject'" />
						<img src="./img/pass.svg" alt="" v-if="item.state === 'handle' || item.state === 'ing'" />
						<img src="./img/success.svg" alt="" v-if="item.state === 'pass'" />
						<div class="handle-mind">
							<img src="./img/user-1.svg" alt="" />
							<div class="handle-title">
								<p :class="{ blue: item.state === 'ing' }">{{ item.handle_res }}</p>
								<p class="text">{{ item.content }}</p>
							</div>
						</div>
						<span class="handle-time">{{ item.title }}：{{ item.time }}</span>
						<div class="line" v-if="i < handleList.length - 1"></div>
					</div>
					<p class="handle-user">{{ item.user }}</p>
				</div>
			</div>

			<div class="main-title" style="margin-top:50px">
				<img src="./img/title-3.svg" alt="" />
				<p>评审反馈</p>
			</div>
			<el-input style="margin-top:20px" type="textarea" resize="none" :rows="6" placeholder="请输入" v-model="textarea">
			</el-input>
		</div>

		<footer>
			<el-button style="width:120px;" size="small" @click="reject()">审核不通过</el-button>
			<el-button style="width:120px;margin-left:20px;" type="primary" size="small" @click="pass()">审核通过</el-button>
		</footer>
	</div>
</template>
<script>
	import dayjs from "dayjs";
	export default {
		props: ["info"],
		components: {},
		data() {
			return {
				list: {},
				handleList: [
					{
						id: "abc1",
						title: "登记时间",
						time: "2021.12.07 09：23",
						state: "handle",
						content: "",
						user: "刘华娣",
						handle_res: "作业登记",
					},
					{
						id: "abc2",
						title: "审核时间",
						time: "2021.12.07 09：24",
						state: "pass",
						content: "系统自动审核通过",
						user: "",
						handle_res: "审核通过",
					},
					{
						id: "abc3",
						title: "审核时间",
						time: "2021.12.08 10：14",
						state: "pass",
						content: "设计富有创意，结合学生实际学情设计针对性作业",
						user: "王恩龙",
						handle_res: "【学科组长】审核通过",
					},
					{
						id: "abc4",
						title: "",
						time: "",
						state: "ing",
						content: "",
						user: "张珊珊",
						handle_res: "【年级组长】待审核",
					},
				],
				textarea: "",
			};
		},
		computed: {},
		watch: {
			info: {
				handler(newVal, oldVal) {
					let ss = sessionStorage;
					let info = newVal.info;
					this.list = {
						sendPeople: JSON.parse(ss.teacherList)[0].label,
						createTime: dayjs(info.createTime).format("YYYY-MM-DD HH:mm"),
						title: info.title,
						deadline: dayjs(info.deadline).format("YYYY-MM-DD HH:mm"),
						estimateDuration: info.estimateDuration + "分钟",
						content: info.content,
						resources: info.resources,
						purpose: info.purpose,
					};
				},
				deep: true,
			},
		},

		created() {},
		mounted() {},
		methods: {
			async getDataList() {},
			toIndex() {
				this.$emit("to-index");
			},
			reject() {},
			pass() {},
		},
	};
</script>
<style lang="less" scoped>
	.detail {
		width: 100%;
		padding: 0px 30px 30px 30px;
		.header {
			height: 60px;
			line-height: 48px;
			margin-bottom: 20px;
			display: flex;
			justify-content: space-between;
			border-bottom: 1px solid #eee;
			align-items: center;
			.span1 {
				font-family: "PingFang SC Bold";
				font-size: 20px;
				color: #000;
				margin-right: 30px;
			}
			.left,
			.right {
				width: 60px;
			}
			.left {
				font-size: 14px;
				color: #8b8b8b;
				cursor: pointer;
			}
		}
		.main {
			width: 100%;
			height: 100%;
			.main-title {
				display: flex;
				align-items: center;
				p {
					font-weight: bold;
					font-size: 14px;
					color: #181c26;
					margin-left: 10px;
				}
			}
			.main-li {
				margin-top: 20px;
				width: 100%;
				display: flex;
				// align-items: center;
				font-size: 14px;
				color: #888;
				p {
					width: 120px;
					text-align: right;
					margin-right: 20px;
				}
				span {
					width: calc(100% - 150px);
					word-wrap:break-word;
				}
			}
		}

		.handle-header {
			display: flex;
			padding-left: 80px;
			margin-top: 20px;
			span {
				width: calc(60% + 53px);
			}
		}
		.handle-item {
			width: 100%;
			height: 50px;
			margin-top: 30px;
			font-size: 14px;
			display: flex;
			align-items: center;
			padding-left: 80px;
			position: relative;
			.line {
				position: absolute;
				width: 1px;
				height: calc(100% + 10px);
				background: #eeeeee;
				left: 90px;
				top: calc(50% + 10px);
			}
			.handle-mind {
				width: 60%;
				margin-left: 15px;
				display: flex;
				align-items: center;
				.handle-title {
					margin-left: 20px;
					.text {
						color: #999999;
						margin-top: 2px;
					}
				}
				.blue {
					color: #4991e1;
				}
			}
			.handle-time {
				margin-left: 20px;
				color: #999999;
			}
		}
		.handle-user {
			color: #666666;
			padding-left: 112px;
		}
	}
	footer {
		margin-top: 50px;
		display: flex;
		justify-content: center;
	}
</style>
